import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import geoConfig from 'Config/geos';
import utils from 'Utils';
import { push } from 'Actions/router';
import SelectGeosInput from 'Components/selectGeosInput';
import shouldDisplayWarning from 'Selectors/shouldDisplayWarning';
import { actionSelectedCategoryChange } from 'Actions';
import config from 'Config/appConfig';
import * as btnStyles from '../../styles/buttons.css';
import * as styles from './selectGeos.css';

const { modZip } = utils.array;

class SelectGeos extends Component {
  componentWillMount() {
    const { activeCategories, selectedCategoriesChange } = this.props;
    if (activeCategories.length) {
      selectedCategoriesChange(activeCategories.map((x) => parseInt(x, 10)));
    }
  }

  render() {
    const { toggleSelectAll, allSelected, displayWarning } = this.props;
    return (
      <div>
        <div className={styles.btnWrapper}>
          <button
            className={btnStyles.buttonBorderDark}
            onClick={toggleSelectAll}
          >
            {!allSelected ? 'Select' : 'Unselect'} All
          </button>
          {displayWarning && (
            <span>
              {config.performanceWarning.selectStateWarning}
            </span>
          )}
        </div>
        { geoConfig.map((group) => (
          <div className={styles.geoGroup} key={group} >
            { group.map((x) => modZip(['id', 'label'], x))
              .map((geo) => (<SelectGeosInput {...geo} key={geo.id} />)) }
          </div>
        ))}
      </div>
    );
  }
}

SelectGeos.propTypes = {
  toggleSelectAll: PropTypes.func.isRequired,
  allSelected: PropTypes.bool.isRequired,
  displayWarning: PropTypes.bool.isRequired,
  activeCategories: PropTypes.array.isRequired,
  selectedCategoriesChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  allSelected: 'all' === state.router.geos,
  displayWarning: shouldDisplayWarning(state),
  activeCategories: state.router.indicators ?
    state.router.indicators
      .reduce((acc, curr) =>
        [...acc].concat(
          state.data.indicators[curr].categories
            .map((x) => `${x}`)
            .filter((x) => !acc.includes(x))
        ), []) : [],
});

const mapDispatchToProps = (dispatch) => ({
  toggleSelectAll: () => dispatch(push({ geos: 'all' })),
  selectedCategoriesChange: (selectedCategories) =>
    dispatch(actionSelectedCategoryChange(selectedCategories)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectGeos);

// Testing exports
export {
  SelectGeos,
  mapStateToProps,
  mapDispatchToProps,
};



// WEBPACK FOOTER //
// ./app/components/selectGeos/index.js